import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { TopicItemServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Topic Item Master section
 */
const useListTopicItem = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ["topic_item_list", page_no],
    TopicItemServices.topicitemList,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};
const useAddTopicItem = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicItemServices.addTopicItem, {
    onSuccess,
    onError,
  });
};
const useUpdateTopicItem = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicItemServices.updateTopicItem, {
    onSuccess,
    onError,
  });
};
const useViewTopicItem = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("topic-view", () => TopicItemServices.viewTopicItem({ id }), {
    onSuccess,
    onError,
  });
};
const useTopicItemDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicItemServices.deleteTopicItem, {
    onSuccess,
    onError,
  });
};
const useGetTopicList = (onSuccess, onError = onDefaultError) => {
  return useQuery("topic-list", TopicItemServices.getTopicList, {
    onSuccess,
    onError,
  });
};
export {
  useListTopicItem,
  useAddTopicItem,
  useGetTopicList,
  useTopicItemDelete,
  useUpdateTopicItem,
  useViewTopicItem,
};
